import { buildWhatsAppLink } from './sendCheckQrWhatsApp';

export const generateTemporaryPassword = () => {
  const randomValues = new Uint32Array(10);
  window.crypto.getRandomValues(randomValues);
  const alphabet = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789';
  const randomPart = Array.from(randomValues, value => alphabet[value % alphabet.length]).join('');
  return `Sd!${randomPart}`;
};

export const buildCollaboratorAccessMessage = ({
  collaboratorName,
  companyName,
  email,
  password,
  loginUrl,
  accessLabel
}) => [
  `Olá, ${collaboratorName}!`,
  '',
  `Seu acesso à ${companyName} foi criado.`,
  '',
  `Link: ${loginUrl}`,
  `Usuário: ${email}`,
  `Senha temporária: ${password}`,
  `Acessos: ${accessLabel}`,
  '',
  'Por segurança, altere sua senha no primeiro acesso e não compartilhe estas credenciais.'
].join('\n');

export const buildCollaboratorAccessWhatsAppLink = ({ phone, ...accessData }) => buildWhatsAppLink({
  phone,
  message: buildCollaboratorAccessMessage(accessData)
});

export const buildCollaboratorContactMessage = ({
  collaboratorName,
  companyName,
  email,
  loginUrl,
  accessLabel
}) => [
  `Olá, ${collaboratorName}!`,
  '',
  `Este é um contato da ${companyName} sobre seu acesso ao SDC Turismo.`,
  '',
  `Link: ${loginUrl}`,
  `Usuário: ${email}`,
  `Acessos: ${accessLabel}`,
  '',
  'Caso precise de uma nova senha, entre em contato com o administrador.'
].join('\n');

export const buildCollaboratorContactWhatsAppLink = ({ phone, ...contactData }) => buildWhatsAppLink({
  phone,
  message: buildCollaboratorContactMessage(contactData)
});
